import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { apiClient } from '../../utils/apiHelper';
import { formatDate } from '../../utils/dateTimeUtils';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const FeeReport = () => {
  const [report, setReport] = useState(null);
  const [month, setMonth] = useState('');
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(false);

  const fetchReport = async () => {
    setLoading(true);
    try {
      let url = '/api/hostel/reports/fee-report';
      const params = [];
      if (month) params.push(`month=${month}`);
      if (year) params.push(`year=${year}`);
      if (params.length > 0) url += `?${params.join('&')}`;
      const response = await apiClient.get(url);
      setReport(response.data || { summary: {}, payments: [] });
    } catch (error) { 
      console.error('Error:', error); 
      setReport({ summary: { total_collected: 0, total_student_payments: 0, student_collection: 0, total_staff_payments: 0, staff_collection: 0 }, payments: [] });
    } finally { 
      setLoading(false); 
    }
  };

  useEffect(() => { fetchReport(); }, []);

  return (
    <div className="p-6 space-y-6">
      <Card>
        <CardHeader><CardTitle>Hostel Fee Report</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-3 gap-4">
            <div><Label>Month</Label><Input value={month} onChange={(e) => setMonth(e.target.value)} placeholder="e.g., January" /></div>
            <div><Label>Year</Label><Input type="number" value={year} onChange={(e) => setYear(parseInt(e.target.value))} /></div>
            <div className="flex items-end"><Button onClick={fetchReport} disabled={loading} className="w-full">{loading ? 'Loading...' : 'Filter'}</Button></div>
          </div>
        </CardContent>
      </Card>

      {report && (
        <>
          <div className="grid grid-cols-3 gap-4">
            <Card><CardContent className="p-6"><div className="text-sm text-gray-600">Total Collected</div><div className="text-3xl font-bold text-green-600">₹{report.summary.total_collected}</div></CardContent></Card>
            <Card><CardContent className="p-6"><div className="text-sm text-gray-600">Student Payments</div><div className="text-3xl font-bold">{report.summary.total_student_payments}</div><div className="text-sm text-gray-500">₹{report.summary.student_collection}</div></CardContent></Card>
            <Card><CardContent className="p-6"><div className="text-sm text-gray-600">Staff Payments</div><div className="text-3xl font-bold">{report.summary.total_staff_payments}</div><div className="text-sm text-gray-500">₹{report.summary.staff_collection}</div></CardContent></Card>
          </div>

          <Card>
            <CardHeader><CardTitle>Payment Details</CardTitle></CardHeader>
            <CardContent>
              <table className="w-full border-collapse">
                <thead><tr className="border-b"><th className="text-left p-3">Payment #</th><th className="text-left p-3">Date</th><th className="text-left p-3">Payer</th><th className="text-left p-3">Type</th><th className="text-left p-3">Month/Year</th><th className="text-left p-3">Amount</th><th className="text-left p-3">Mode</th></tr></thead>
                <tbody>
                  {report.payments.length === 0 ? <tr><td colSpan="7" className="text-center p-4 text-gray-500">No payments found for the selected period.</td></tr> : report.payments.map((payment) => (
                    <tr key={payment.id} className="border-b hover:bg-gray-50">
                      <td className="p-3 font-medium">{payment.payment_number}</td>
                      <td className="p-3">{formatDate(payment.payment_date)}</td>
                      <td className="p-3">{payment.payer_name}</td>
                      <td className="p-3"><span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-800">{payment.payer_type}</span></td>
                      <td className="p-3">{payment.month} {payment.year}</td>
                      <td className="p-3 text-green-600 font-medium">₹{payment.amount}</td>
                      <td className="p-3">{payment.payment_mode}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </>
      )}
    </div>
  );
};

export default FeeReport;